// extracted by mini-css-extract-plugin
module.exports = {"container":"candidateProfileModal_container__2uY5q","profileContainer":"candidateProfileModal_profileContainer__20AVS","closeButton":"candidateProfileModal_closeButton__xybc1"};